// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"3f1cd644","453":"14a8997e","765":"1418957d","910":"31001af8","992":"fd9b1ab3"}[chunkId] + ".chunk.js";
};